import { render, staticRenderFns } from "./bamboo_users_table.vue?vue&type=template&id=fde54088&"
import script from "./bamboo_users_table.vue?vue&type=script&lang=js&"
export * from "./bamboo_users_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports